const shellPrefs = {
  title: "Frame Preferences",
  sidebarHover: "Sidebar on Hover",
  sidebarWidth: "Sidebar Width",
  topbarVisible: "Show Top Bar",
  topbarHover: "Top Bar on Hover",
  tabbarVisible: "Show Tab Bar",
  trayVisible: "Show Work Tray",
  speedDialVisible: "Show Speed Dial",
  hoverHint: "Appears on edge hover",
  resetDefaults: "Reset to Defaults",
} as const;
export default shellPrefs;
